import type { Blueprint } from '@builder/base/blueprints/Blueprint';
import type { ValidatableBlueprint } from '@builder/base/blueprints/ValidatableBlueprint';
import type { HasWidth } from '@builder/base/traits/HasWidth';
import type { ValidationErrors } from '@builder/base/types/ValidationErrors';
import type { BlueprintDefinition } from '@builder/form/blueprints/BlueprintDefinition';
import type { VisibleBlueprint } from '@builder/form/blueprints/VisibleBlueprint';
import { AlwaysChoice } from '@builder/form/enums/AlwaysChoice';
import type { InternallyChoice } from '@builder/form/enums/InternallyChoice';
import type { NeverChoice } from '@builder/form/enums/NeverChoice';
import type { WhenChoice } from '@builder/form/enums/WhenChoice';

export const Definition: BlueprintDefinition = {
    type: 'info',
    name: '[[[Info]]]',
    icon: 'fa-info',
    group: 'special',
    position: 9
};

export interface InfoContract extends Blueprint, VisibleBlueprint, HasWidth
{
    info: Record<string, string>;
}

export class InfoType implements InfoContract, ValidatableBlueprint
{
    public id: string;
    public type: string;
    public name: string;
    public minWidth: number;
    public width: number;
    public visible: AlwaysChoice | NeverChoice | InternallyChoice | WhenChoice;
    public visibleWhen: string;
    public info: Record<string, string>;
    public icon: string;
    public alertType: number;
    public errors: ValidationErrors;

    public constructor(id: string, name: string)
    {
        this.id = id;
        this.type = Definition.type;
        this.name = name;
        this.minWidth = 1;
        this.width = 0;
        this.visible = AlwaysChoice.Always;
        this.visibleWhen = null;
        this.info = {};
        this.errors = {};
    }

    public setDefaultWidth(width: number): void
    {
        this.width = Math.max(this.minWidth, width);
    }

    public validate(): Record<string, ValidationErrors>
    {
        this.errors = {};

        return {
            [this.name]: this.errors
        };
    }
}
